/* mk-cart.js : ajout au panier par /cart/add.js, ouverture du tiroir, re-rendu depuis /?section_id=mk-cart-drawer et /cart.js,
   quantité et suppression. Sans JS : la page /cart. (Repris de ksb-cart.js du kit A.) */
(function () {
  var d = document.getElementById('cart-drawer'); if (!d || !d.showModal) return;
  var count = document.querySelector('[data-cart-count]');
  function open() { if (!d.open) d.showModal(); var b = d.querySelector('.cdr-body'); if (b) b.scrollTop = 0; }
  // 25/10 vitesse : le tiroir s'ouvre tout de suite ; add.js / change.js renvoient le tiroir re-rendu (sections=), 1 seul aller-retour.
  function paint(html) { var n = html && new DOMParser().parseFromString(html, 'text/html').getElementById('cart-drawer'); if (n) d.innerHTML = n.innerHTML; d.classList.remove('is-busy'); }
  function count2() { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if (count) { count.textContent = c.item_count; count.hidden = !c.item_count; } }).catch(function () {}); }
  function refresh(then) {
    return fetch('/?section_id=mk-cart-drawer').then(function (r) { return r.text(); }).then(function (h) { paint(h); count2(); if (then) then(); });
  }
  function change(line, qty) {
    d.classList.add('is-busy');
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty, sections: 'mk-cart-drawer' }) })
      .then(function (r) { return r.json(); }).then(function (c) { paint(c.sections && c.sections['mk-cart-drawer']); if (count) { count.textContent = c.item_count; count.hidden = !c.item_count; } })
      .catch(function () { refresh(); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('form[data-ajax-cart]')) {
      e.preventDefault(); var b = f.querySelector('[type=submit]'); if (b) { b.setAttribute('aria-busy', 'true'); b.dataset.t = b.dataset.t || b.textContent; }
      d.classList.add('is-busy'); open();
      var fd = new FormData(f); fd.append('sections', 'mk-cart-drawer');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (j) { if (j.sections && j.sections['mk-cart-drawer']) { paint(j.sections['mk-cart-drawer']); count2(); } else return refresh(); })
        .catch(function () { d.close(); f.removeAttribute('data-ajax-cart'); f.submit(); })
        .finally(function () { if (b) b.removeAttribute('aria-busy'); });
    } else if (f.matches('.qty')) { e.preventDefault(); change(+f.line.value, +f.quantity.value); }
    else if (f.matches('.rm') && d.contains(f)) { e.preventDefault(); change(+f.line.value, 0); }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cdr-close]')) { d.close(); return; }
    var s = e.target.closest('[data-step]');
    if (s) { var f = s.closest('form'), q = f.quantity; change(+f.line.value, Math.max(0, +q.value + +s.dataset.step)); return; }
    var a = e.target.closest('a[href$="/cart"]');
    if (a && !d.contains(a) && !e.metaKey && !e.ctrlKey) { e.preventDefault(); refresh(open).catch(function () { location.href = a.href; }); }
  });
  d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
})();
